export enum ScoreRange {
  NotApplicable = 'not-applicable',
  VeryLow = 'very-low',
  Low = 'low',
  Moderate = 'moderate',
  High = 'high',
  VeryHigh = 'very-high',
  Unscored = 'unscored',
}

export enum ScoreColorVariant {
  NotApplicable = 'notApplicable',
  VeryLow = 'veryLow',
  Low = 'low',
  Moderate = 'moderate',
  High = 'high',
  VeryHigh = 'veryHigh',
}

export enum ScoreDescriptions {
  NotApplicable = 'Informational',
  VeryLow = 'Very Low',
  Low = 'Low',
  Moderate = 'Moderate',
  High = 'High',
  VeryHigh = 'Very High',
  Unscored = 'Informational',
}
